import styled from 'styled-components';

export const ColorBlock = styled.span`
    background-color: ${props => props.color};
    width: 12px;
    height: 12px;
    border-radius: 100px;
    margin-top: ${props => (props.noMargin ? '0' : 'auto')};
    margin-bottom: ${props => (props.noMargin ? '0' : 'auto')};
    margin-right: ${props => (props.noMargin ? '0' : '9px')};
    margin-left: ${props => (props.noMargin ? '0' : '6.5px')};
`;

export const ColorBlockV2 = styled.span`
    display: block;
    background-color: ${props => props.color};
    width: 12px;
    height: 12px;
    border-radius: 100px;
    margin-left: 9px;
`;

export const CategoryAllocation = styled.span`
    background: #ecf0f1;
    border-radius: 5px;
    padding: 3px 7px;
    color: #2c3e50;
    height: 20px;
    line-height: 14px;
    font-size: 11px;
    margin: -1px 0 0 5px;
`;
